import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
  d="M50,38 C50,33.5 46.5,30.3 42,30.3 L35,30.3 C30.5,30.3 27,33.5 27,38 L27,42.6 C27,47.1 30.5,50.3 35,50.3 L42,50.3 C43.7,50.3 45,51.6 45,53.3 C45,55 43.7,56.3 42,56.3 L35,56.3 C33.3,56.3 32,55 32,53.3 L32,51.3 L27,51.3 L27,53.3 C27,57.8 30.5,61 35,61 L42,61 C46.5,61 50,57.8 50,53.3 L50,48.7 C50,44.2 46.5,41 42,41 L35,41 C33.3,41 32,39.7 32,38 C32,36.3 33.3,35 35,35 L42,35 C43.7,35 45,36.3 45,38 L45,40 L50,40 L50,38 Z"
  fill="currentColor"
/>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
